import type Creative from './Creative';
import { type IDynamicProperty } from './DynamicProperties/IDynamicProperty';
import { merge } from './DynamicProperties/merge';
import DynamicGroup from './DynamicProperties/Types/Group';
import { DynamicProperty } from './DynamicProperties/Types/Property';
import Store from './Store';

export default class ClipboardManager extends Store {
  current = new DynamicGroup(null, 'clipboard', []);
  parent: Creative;

  get valuesCopied() {
    return this.current.properties.length > 0;
  }

  constructor(parent: Creative) {
    super();
    this.parent = parent;
    this.becomeObservable();
  }

  copy = (property: IDynamicProperty<any>) => {
    this.current.reset();
    if(property instanceof DynamicGroup) {
      this.current.addGroup(property.name, property.properties);
    } else {
      this.current.addProperty(property);
    }
  }

  paste = (targetProperty: IDynamicProperty<any>) => {
    const properties = this.current.properties;
    if (!properties || properties.length === 0) return;
    if (properties.length === 1) {
      const copiedProperty = this.current.properties[0];

      // If you've copied a group and are pasting to a group...
      if (
        targetProperty instanceof DynamicGroup &&
        copiedProperty instanceof DynamicGroup
      ) {
        merge(targetProperty, copiedProperty, { addMissing: false });
      }

      // If you've copied a single property and are pasting to a group...
      else if(targetProperty instanceof DynamicGroup && copiedProperty instanceof DynamicProperty) {
        console.log('Pasting a single property to a group');
        if (targetProperty.getChild(copiedProperty.name)) {
          console.log('attempting...');
          targetProperty.getChild(copiedProperty.name)?.set(copiedProperty.value);
        }
      }

      // If you've copied a single property and are pasting to a single property...
      else if (targetProperty instanceof DynamicProperty && copiedProperty instanceof DynamicProperty) {
        if (
          targetProperty.type === copiedProperty.type /* && */
          /* targetProperty.name === copiedProperty.name */
        ) {
          targetProperty.set(copiedProperty.value);
        } else {
          throw new Error(`Cannot paste a property of type "${copiedProperty.type}" to a property of type "${targetProperty.type}".`);
        }
      }
    }
    
    // If you've copied multiple different properties and are pasting to a group...
    else {
      if (targetProperty instanceof DynamicGroup) {
        merge(targetProperty, this.current, { addMissing: false });
      } else {
        throw new Error(`Cannot paste multiple properties to a single property.`);
      }
    }
  };
}
